// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lm8XCS6cQNKELnqU7ylQ{display:flex;flex-direction:column;padding-bottom:32px}`, "",{"version":3,"sources":["webpack://./src/pages/chatbot/ui/ChatbotEdit/StepFallbackActions/FallbackSettings/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,mBAAA","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `lm8XCS6cQNKELnqU7ylQ`
};
export default ___CSS_LOADER_EXPORT___;
